export enum State {
  Undefined = 'Undefined',
  Loading = 'Loading',
  Error = 'Error',
  Defined = 'Defined',
}
